import { pick } from 'lodash';
import appConstants from '../../../../../../appConstants';

export const getDriverStopDetails = ({ activeDriverDetails, historicDriverDetails }) => {
  return activeDriverDetails
    ? getActiveDriverStopDetails(activeDriverDetails)
    : getHistoricDriverStopDetails(historicDriverDetails);
};

const isPickupIdInStop = (stop, pickupId) => {
  const normalizedPickupId = pickupId?.toLowerCase();
  const pickupIdsOnStop = stop.pickupIdList?.length ? stop.pickupIdList : [stop.pickupId];
  return pickupIdsOnStop.some((id) => id?.toLowerCase() === normalizedPickupId);
};

const getActiveDriverStopDetails = ({ currentActiveRoutes, pickupInfo }) => {
  if (!currentActiveRoutes) return null;
  const driver = currentActiveRoutes.find(
    (driver) => driver.driverId?.toLowerCase() === pickupInfo.driverId?.toLowerCase()
  );
  if (driver?.stops) {
    return {
      ...pick(driver, ['driverId', 'routeId']),
      stops: driver.stops.filter(
        (stop) => isPickupIdInStop(stop, pickupInfo.pickupId)
      )
    };
  }
  return null;
};

const getHistoricDriverStopDetails = ({ routeData, stopId }) => {
  if (!routeData) return null;
  const stops = routeData?.stops;
  return stops
    ? {
        ...pick(routeData, ['driverId', 'routeId']),
        stops: stops.filter((stop) => stop.stopId?.toLowerCase() === stopId?.toLowerCase())
      }
    : null;
};

export const getDriverStopDetailsForPastPickup = ({ pastPickupDetails, pastPickupShipments }) => {
  return {
    stops: [
      {
        ...Object.fromEntries(
          Object.entries(
            pick(pastPickupDetails, [
              'stopId',
              'shipperName',
              'shipperAddress1',
              'shipperAddress2',
              'shipperCity',
              'shipperState',
              'shipperZip',
            ])
          ).map(([key, value]) => {
            // Rename keys as per mapping
            const keyMap = {
              shipperName: 'name',
              shipperAddress1: 'address',
              shipperAddress2: 'address2',
              shipperCity: 'city',
              shipperState: 'state',
              shipperZip: 'zip',
            };
            return [keyMap[key] || key, value];
          })
        ),
        stopSequence: 'NA',
        stopType: appConstants.STOP_TYPE.Pickup,
        shipments:
          pastPickupShipments?.map((shipment) => ({
            ...pick(shipment, ['proId']),
          })) ?? [],
      },
    ],
  };
};
